import { defineMessages } from "@/i18n";
import en from "./en";

export const framesHtmlMessages = defineMessages("frames-html", en);
